import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Setting your location will refresh the page.", -1)
const _hoisted_2 = { class: "location-modal__form" }
const _hoisted_3 = { class: "location-modal__form__geo" }
const _hoisted_4 = ["id"]
const _hoisted_5 = {
  id: "location-modal__form__geo__hint",
  class: "location-modal__form__geo__hint"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "location-modal__form__or" }, "or", -1)
const _hoisted_7 = { class: "location-modal__form__postcode" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Postcode", -1)
const _hoisted_9 = ["aria-invalid"]
const _hoisted_10 = {
  role: "alert",
  id: "postcodeErrorMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_location = _resolveComponent("icon-location")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    "button-label": _ctx.isLocationSet ? 'Change my location' : 'Set my location',
    "modal-heading": "Discover events near you",
    "initial-focus-id": `#${_ctx.initialFocusId}`
  }, {
    icon: _withCtx(() => [
      _createVNode(_component_icon_location)
    ]),
    description: _withCtx(() => [
      _hoisted_1
    ]),
    contents: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleGeoClick && _ctx.handleGeoClick(...args))),
            class: "primary-button",
            id: _ctx.initialFocusId,
            "aria-describedby": "location-modal__form__geo__hint"
          }, " Use my location ", 8, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("div", null, " Your browser will request permission to use your location. ", 512), [
              [_vShow, !_ctx.geoError]
            ]),
            _withDirectives(_createElementVNode("div", {
              role: "alert",
              id: "geoErrorMessage"
            }, " ⚠ " + _toDisplayString(_ctx.geoError), 513), [
              [_vShow, _ctx.geoError]
            ])
          ])
        ]),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", null, [
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "aria-invalid": _ctx.invalidPostcode,
              "aria-describedby": "postcodeErrorMessage",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.postcode) = $event)),
              onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.handlePostcodeClick && _ctx.handlePostcodeClick(...args)), ["prevent"]), ["enter"]))
            }, null, 40, _hoisted_9), [
              [
                _vModelText,
                _ctx.postcode,
                void 0,
                { trim: true }
              ]
            ])
          ]),
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handlePostcodeClick && _ctx.handlePostcodeClick(...args))),
            class: "primary-button"
          }, " Set postcode "),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.invalidPostcode
                ? "⚠ Please enter a valid Australian postcode."
                : ""), 1)
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        class: "link-button",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.removeLocation && _ctx.removeLocation(...args)))
      }, " Remove my location ")
    ]),
    _: 1
  }, 8, ["button-label", "initial-focus-id"]))
}